module.exports = __webpack_public_path__ + "img/title-signup@2x.3db016ec.png";